import Vue from 'vue'
import Router from 'vue-router'

// Main
import Content from '@/components/content/Content'

// Budgets
import BudgetsIndex from '@/components/budgets/BudgetsIndex'
import Landing from '@/components/budgets/landing/Landing'

import EditBudgetPage from '@/components/budgets/EditBudgetPage'

import MarketRentIndex from '@/components/budgets/worksheet/MarketRentIndex'
import BaseRent from '@/components/budgets/worksheet/tabs/BaseRent'
import Renovations from '@/components/budgets/worksheet/tabs/Renovations'
import Amenities from '@/components/budgets/worksheet/tabs/Amenities'

import OccupancyIndex from '@/components/budgets/worksheet/OccupancyIndex'
import ModelAdminDown from '@/components/budgets/worksheet/tabs/ModelAdminDown'
import MoveInsMoveOuts from '@/components/budgets/worksheet/tabs/MoveInsMoveOuts'
import ActualRent from '@/components/budgets/worksheet/tabs/ActualRent'
import RentalDeductions from '@/components/budgets/worksheet/tabs/RentalDeductions'

import GeneralLedgerIndex from '@/components/budgets/general-ledger/GeneralLedgerIndex'
import GLGroups from '@/components/budgets/general-ledger/detail/GLGroups'
import GroupGLAccountBudgets from '@/components/budgets/general-ledger/detail/GroupGLAccountBudgets'

import WorkingDraft from '@/components/budgets/WorkingDraft'
import Documents from '@/components/budgets/Documents'

// Templates
import TemplatesIndex from '@/components/templates/TemplatesIndex'
import GLAccountTemplatesLanding from '@/components/templates/landing/GLAccountTemplatesLanding'
import SettingsTemplatesLanding from '@/components/templates/landing/SettingsTemplatesLanding'
import EditSettingsTemplatePage from '@/components/templates/EditSettingsTemplatePage'

import BudgetGroupsIndex from '@/components/templates/budget-groups/BudgetGroupsIndex'

// Global
import GlobalIndex from '@/components/global/GlobalIndex'
import BulkBudgetCreation from '@/components/global/BulkBudgetCreation'
import BulkCalculationsAssumptions from '@/components/global/BulkCalculationsAssumptions'
import SettingsSummary from '@/components/global/SettingsSummary'

// Etc...
import AccessDenied from '../components/auth/AccessDenied'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Content,
      meta: {
        requiresAuth: false // TODO
      },
      redirect: {
        name: 'Landing'
      },
      children: [
        // Budgets
        {
          path: 'Budgets',
          component: BudgetsIndex,
          children: [
            // Landing
            {
              path: '',
              name: 'Landing',
              component: Landing,
              children: []
            },
            // Settings
            {
              path: ':budgetIterationId/Settings',
              name: 'Settings',
              component: EditBudgetPage,
              alias: ':budgetIterationId',
              props: true,
              children:[]
            },
            // Worksheet - Market Rent
            {
              path: ':budgetIterationId/MarketRent',
              name: 'MarketRent',
              component: MarketRentIndex,
              alias: ':budgetIterationId',
              props: true,
              redirect: {
                name: 'BaseRent'
              },
              children: [
                // Base Rent
                {
                  path: 'BaseRent',
                  name: 'BaseRent',
                  component: BaseRent,
                  props: true,
                  children: []
                },
                // Renovations
                {
                  path: 'Renovations',
                  name: 'Renovations',
                  component: Renovations,
                  props: true,
                  children: []
                },
                // Amenities
                {
                  path: 'Amenities',
                  name: 'Amenities',
                  component: Amenities,
                  props: true,
                  children: []
                },
              ]
            },
            // Worksheet - Occupancy
            {
              path: ':budgetIterationId/Occupancy',
              name: 'Occupancy',
              component: OccupancyIndex,
              props: true,
              redirect: {
                name: 'ModelAdminDown'
              },
              children: [
                // ModelAdminDown
                {
                  path: 'ModelAdminDown',
                  name: 'ModelAdminDown',
                  component: ModelAdminDown,
                  props: true,
                  children: []
                },
                // MoveIns
                {
                  path: 'MoveInsMoveOuts',
                  name: 'MoveInsMoveOuts',
                  component: MoveInsMoveOuts,
                  props: true,
                  children: []
                },
                // ActualRent
                {
                  path: 'ActualRent',
                  name: 'ActualRent',
                  component: ActualRent,
                  props: true,
                  children: []
                },
                // RentalDeductions
                {
                    path: 'RentalDeductions',
                    name: 'RentalDeductions',
                    component: RentalDeductions,
                    props: true,
                    children: []
                  },
              ]
            },
            // GL Accounts
            {
              path: ':budgetIterationId/GL',
              component: GeneralLedgerIndex,
              props: true,
              children: [
                // Actual GL tab
                {
                  path: 'Groups',
                  name: 'Groups',
                  component: GLGroups,
                  props: true,
                  children: [
                    {
                        path: ':groupId/Accounts',
                        name: 'GroupGLAccountBudgets',
                        component: GroupGLAccountBudgets,
                        props: true,
                      alias: ':groupId',
                        children: []
                    }
                 ]
                }
              ]
            },
            // Other - Working Draft
            {
              path: ':budgetIterationId/WorkingDraft',
              name: 'WorkingDraft',
              component: WorkingDraft,
              props: true,
              children: []
            },
            // Other - Documents
            {
              path: ':budgetIterationId/Documents',
              name: 'Documents',
              component: Documents,
              props: true,
              children: []
            },
          ]
        },
        // Templates
        {
          path: 'Templates',
          component: TemplatesIndex,
          children: [
            {
              path: '',
              name: 'GLAccountTemplatesLanding',
              component: GLAccountTemplatesLanding,
              children: []
            },
            {
              path: 'SettingsTemplates',
              name: 'SettingsTemplatesLanding',
              component: SettingsTemplatesLanding,
              children: []
            },
            {
              path: ':settingsTemplateId/EditSettingsTemplate',
              name: 'EditSettingsTemplate',
              props: true,
              component: EditSettingsTemplatePage,
              children: []
            },
            // Budget Groups
            {
              path: ':templateId/BudgetGroups',
              name: 'BudgetGroups',
              component: BudgetGroupsIndex,
              alias: ':templateId',
              props: true,
              children: []
            }
          ]
        },
        // Global
        {
          path: 'Global',
          name: 'Global',
          component: GlobalIndex,
          children: [
            {
              path: '',
              name: 'BulkBudgetCreation',
              component: BulkBudgetCreation,
              children: []
            },
            {
              path: 'BulkCalculationsAssumptions',
              name: 'BulkCalculationsAssumptions',
              component: BulkCalculationsAssumptions,
              children: []
            },
            {
              path: 'SettingsSummary',
              name: 'SettingsSummary',
              component: SettingsSummary,
              children: []
            }
          ]
        }
      ]
    },
    {
      path: '/AccessDenied',
      name: 'accessdenied',
      component: AccessDenied
    },
    {
      path: '*',
      redirect: {
        name: 'Landing'
      }
    }
  ]
})
